import React from 'react';
import { PannierProduct } from '../../Types/Types.ts';

type HorizontalOptionProps = {
  option: PannierProduct;
  isSelected: boolean;
  onClick: () => void;
};

const HorizontalOption = ({ option, isSelected, onClick }: HorizontalOptionProps) => {
  return (
    <div className={`horizontal-option d-flex mb-4 px-1 py-1 ${isSelected ? 'selected' : ''}`} onClick={onClick}>
      <div className="image-wrapper d-flex justify-content-center w-100">
        {option.Image && <img src={option.Image} alt={option.AltText!}></img>}
      </div>
      <div className="info d-flex flex-column justify-content-center">
        <h6 className="mb-1">{option.Name}</h6>
        <p className={`${!option.Webtitle2 ? 'd-none' : ''}`}>{option.Webtitle2}</p>
        <h6 className={`${!option.Price ? 'd-none' : ''}`}>+ {option.Price}</h6>
      </div>
      <div className="checkmark-container">{isSelected && <i className="le-icon-check"></i>}</div>
    </div>
  );
};

export default HorizontalOption;
